import _ from "underts";
import z from "zod/v4";
import { Enum } from "enum-plus";
const paymentMethods = {
    ESPECES: "Espèces",
    CHEQUE: "Chèque",
    CB: "CB",
    VIR: "Virement",
};
const paymentMethodsNums = {
    ESPECES: 1,
    CHEQUE: 2,
    CB: 3,
    VIR: 4,
};
// function Enum<Key extends string, Values extends number>(
//   config: Record<Key, { value: Values; label: string }>
// ) {
//   const items = Object.entries(config).map(([key, configValue]) => {
//     const { value, label } = configValue as { value: Values; label: string };
//     return {
//       key: key as Key,
//       value: value as Values,
//       label,
//     };
//   });
//   const valueType = items.map((item) => item.value)[Math.random()];
//   const keyType = items.map((item) => item.key)[Math.random()];
//   const keys = items.map((item) => item.key) as Key[];
//   function key(value: Values): Key {
//     const item = items.find((item) => item.value === value);
//     if (!item) {
//       throw new Error(`Key for value ${value} not found in enum`);
//     }
//     return item.key;
//   }
//   const valuesMap: Record<Key, Values> = keys.reduce(
//     (acc, key) => {
//       const item = items.find((item) => item.key === key);
//       if (item) {
//         acc[item.key] = item.value;
//       }
//       return acc;
//     },
//     {} as Record<Key, Values>
//   );
//   return {
//     items,
//     valueType,
//     keyType,
//     keys,
//     key,
//     ...valuesMap,
//   };
// }
export const RdvTypeEnums = Enum({
    PCONSULT: { value: 1, label: "1ère consult" },
    URGENCE: { value: 2, label: "urgence" },
    RETPANO: { value: 3, label: "retour pano" },
    RETMUT: { value: 4, label: "retour mutuelle" },
    RESTAU: { value: 5, label: "restau" },
    DET: { value: 6, label: "détartrage" },
    EXT: { value: 7, label: "extraction" },
    BLABLA: { value: 8, label: "blahblah" },
    MALPROG: { value: 9, label: "rdv mal programmé" },
    PARO: { value: 10, label: "paro" },
    LAPIN: { value: 11, label: "lapin" },
    ANNTARD: { value: 12, label: "annulation tardive" },
    PROT: { value: 13, label: "prothèse" },
    ODF: { value: 14, label: "orthodontie" },
    FERME: { value: 15, label: "fermé" },
    RETPATIENT: { value: 16, label: "retour patient" },
    CTRLROUT: { value: 17, label: "ctrl de routine" },
    POSEIMPL: { value: 18, label: "pose implant" },
    PDT: { value: 19, label: "plan de traitement" },
    DIV: { value: 20, label: "divers" },
    ANN: { value: 21, label: "annulé" },
    MANQRET: { value: 22, label: "retard pas pris" },
    DOULEUR: { value: 23, label: "douleur" },
    IMPLANT: { value: 24, label: "implant" },
    FORBIDDEN: { value: 25, label: "interdit" },
    NPDOCTO: { value: 26, label: "nouveau patient Docto" },
    RETURNINGDOCTO: { value: 27, label: "retour patient Docto" },
    RESERVEDFORDOCTO: { value: 28, label: "Réservé Doctolib" },
    CLOSEDBYHORAIRES: { value: 29, label: "Fermé (horaires)" },
});
export const rdvTypeValues = RdvTypeEnums.items.map((item) => item.value);
export const RdvTypeValuesSchema = z.literal(rdvTypeValues);
const typeConsts = {
    PCONSULT: 1,
    URGENCE: 2,
    RETPANO: 3,
    RETMUT: 4,
    RESTAU: 5,
    DET: 6,
    EXT: 7,
    BLABLA: 8,
    MALPROG: 9,
    PARO: 10,
    LAPIN: 11,
    ANNTARD: 12,
    PROT: 13,
    ODF: 14,
    FERME: 15,
    RETPATIENT: 16,
    CTRLROUT: 17,
    POSEIMPL: 18,
    PDT: 19,
    DIV: 20,
    ANN: 21,
    MANQRET: 22,
    DOULEUR: 23,
    IMPLANT: 24,
    FORBIDDEN: 25,
    NPDOCTO: 26,
    RETURNINGDOCTO: 27,
    RESERVEDFORDOCTO: 28,
    CLOSEDBYHORAIRES: 29,
};
const fakeAptTypes = [
    typeConsts.ANN,
    typeConsts.ANNTARD,
    typeConsts.CLOSEDBYHORAIRES,
    typeConsts.FERME,
    typeConsts.FORBIDDEN,
    typeConsts.LAPIN,
    typeConsts.MALPROG,
    typeConsts.MANQRET,
    typeConsts.RESERVEDFORDOCTO,
];
export const isRealApt = (apt) => {
    return !_.includes(fakeAptTypes, apt.type);
};
// export const typeNums = Object.values(typeConsts);
// export type typeNumsType = (typeof typeNums)[number];
const typeTranslator = {
    //	TYPE:"type",
    PCONSULT: "1ère consult",
    URGENCE: "urgence",
    RETPANO: "retour pano",
    RETMUT: "retour mutuelle",
    RESTAU: "restau",
    DET: "détartrage",
    EXT: "extraction",
    BLABLA: "blahblah",
    MALPROG: "rdv mal programmé",
    PARO: "paro",
    LAPIN: "lapin",
    ANNTARD: "annulation tardive",
    PROT: "prothèse",
    ODF: "orthodontie",
    FERME: "fermé",
    RETPATIENT: "retour patient",
    CTRLROUT: "ctrl de routine",
    POSEIMPL: "pose implant",
    PDT: "plan de traitement",
    DIV: "divers",
    ANN: "annulé",
    MANQRET: "retard pas pris",
    DOULEUR: "douleur",
    IMPLANT: "implant",
    FORBIDDEN: "interdit",
    NPDOCTO: "nouveau patient Docto",
    RETURNINGDOCTO: "retour patient Docto",
    RESERVEDFORDOCTO: "Réservé Doctolib",
    CLOSEDBYHORAIRES: "Fermé (horaires)",
};
export const typesNames = Object.values(typeTranslator);
const motifsMap = {
    DET: "détartrage",
    CTRL: "contrôle de routine",
    DLR: "douleur légère/moyenne",
    DKCTROU: "dent cassée/avec un trou/plombage perdu",
    IMPLANT: "implant",
    RESC: "couronne à resceller",
    GENCIVE: "problème de gencive",
    BILAN: "bilan",
    DDS: "dent de sagesse",
    TRAUMA: "choc/accident",
    ORTHO: "orthodontie",
    COUR: "couronne à faire/refaire",
    DEVIS: "devis",
    URGENCE: "urgence",
    CARIE: "carie",
    PARO: "séance de soins des gencives (paro)",
    EXTRAC: "extraction",
    BLABLA: "discussion",
    DUREE: "durée spécifique",
    AUTRE: "autre",
    PROT: "prothèse",
};
const motifsNames = Object.values(motifsMap);
const motifConsts = {
    DET: 1,
    CTRL: 2,
    DLR: 3,
    DKCTROU: 4,
    IMPLANT: 5,
    RESC: 6,
    GENCIVE: 7,
    BILAN: 8,
    DDS: 9,
    TRAUMA: 10,
    ORTHO: 11,
    COUR: 12,
    DEVIS: 13,
    URGENCE: 14,
    CARIE: 15,
    PARO: 16,
    EXTRAC: 17,
    BLABLA: 18,
    DUREE: 19,
    AUTRE: 20,
    PROT: 21,
};
const adrConsts = {
    ANNU: 1,
    FAMILY_PATIENT: 2,
    OTHER_PATIENT: 3,
    OTHER_MEAN: 4,
};
const adrKeysMap = {
    ANNU: "ANNU",
    FAMILY_PATIENT: "FAMILY_PATIENT",
    OTHER_PATIENT: "OTHER_PATIENT",
    OTHER_MEAN: "OTHER_MEAN",
};
const adrKeys = [
    "ANNU",
    "FAMILY_PATIENT",
    "OTHER_PATIENT",
    "OTHER_MEAN",
];
const etatCivilStrings = {
    NAME: "Nom",
    FORENAME: "Prénom",
    MAIDEN_NAME: "Nom de naissance",
    BIRTHDATE: "Date naissance",
    PORTABLEE164: "Portable",
    EMAIL: "E-mail",
    COMMENTS: "Commentaires",
};
const rdvPotentiels = {
    PPRDV: 0,
    URGENCE: 1,
    PB: 7,
    HPRDV: 8,
};
const patientFlags = ["pp", "pv", "vip", "bl"];
const patientFlagsKeys = {
    pp: "pp",
    pv: "pv",
    vip: "vip",
    bl: "bl",
};
const jours = [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
];
const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
];
export const dayToJour = (day) => {
    const index = days.indexOf(day);
    return jours[index];
};
export const jourToDay = (jour) => {
    const index = jours.indexOf(jour);
    return days[index];
};
export const getMotifConstFromMotifName = (name) => {
    const keys = Object.keys(motifsMap);
    return keys.filter((key) => motifsMap[key] === name)[0];
};
const getMotifNumberFromMotifName = (name) => motifConsts[getMotifConstFromMotifName(name)];
const getTypeConstFromTypeNumber = (typeNumber) => {
    const numsAvailable = Object.values(typeConsts);
    if (!numsAvailable.includes(typeNumber)) {
        //console.warn("typeNumber submitted to getTypeConstFromTypeNumber doesn't exist");
        //throw new Error("typeNumber submitted to getTypeConstFromTypeNumber doesn't exist");
    }
    const arr = Object.keys(typeConsts).reduce((result, key) => ({ ...result, [typeConsts[key]]: key }), {});
    return arr[typeNumber];
};
export const getTypeNumberFromTypeName = (typeName) => {
    const typeConst = getTypeConstFromTypeName(typeName);
    return typeConsts[typeConst];
};
export const getTypeNameFromTypeNumber = (typeNumber) => {
    const typeConst = getTypeConstFromTypeNumber(typeNumber);
    return typeTranslator[typeConst];
};
const getTypeConstFromTypeName = (name) => {
    const found = Object.entries(typeTranslator).find(([_key, value]) => value === name);
    if (!!found) {
        return found[0];
    }
    else {
        throw new Error("name not found in getTypeConstFromTypeName");
    }
};
const getPaymentMethodKeyFromNumber = (paymentMethodNumber) => {
    const inverted = _.invert(paymentMethodsNums);
    return inverted[paymentMethodNumber];
};
const assuConstNums = {
    CPAM: 1,
    CMUc: 2,
    AME: 3,
};
const assuConstKeys = {
    CPAM: "CPAM",
    CMUc: "CMUc",
    AME: "AME",
};
const assurancesKeys = ["CPAM", "CMUc", "AME"];
export { jours, days, typeConsts, typeTranslator, motifsMap, motifsNames, motifConsts, etatCivilStrings, adrConsts, adrKeys, adrKeysMap, rdvPotentiels, paymentMethods, paymentMethodsNums, getMotifNumberFromMotifName, getTypeConstFromTypeNumber, getTypeConstFromTypeName, getPaymentMethodKeyFromNumber, patientFlags, patientFlagsKeys, assurancesKeys, assuConstNums, assuConstKeys, };
//lie les mots clefs de demande patient aux mots utilisés par les patients
//une demande correspond à ce que rentre le patient dans l'interface
export const demandeToWords = {
    DET: ["détartrage", "detartrage", "det"],
    CTRL: ["contrôle", "ctrl", "cont", "routine", "vérification", "vérifier"],
    DLR: ["douleur", "mal", "rage", "dormir", "forte", "nuit"],
    DKC: ["cassée"],
    TROU: ["trou"],
    IMPLANT: ["implant"],
    RESC: ["perdu", "décollé", "descellé", "tombé"],
    GENCIVE: ["gencive"],
    BILAN: ["bilan", "point"], //différence avec CTRL ?
    DDS: ["sagesse"],
    TRAUMA: ["tombé"],
    ORTHO: ["orthodontie", "odf", "ortho", "orthodontiste"],
    COUR: ["couronne"],
    DEVIS: ["devis"],
    URGENCE: ["urgence", "douleur", "mal", "rage", "dormir", "forte", "nuit"],
    CARIE: ["carie"],
    EXTRAC: ["extraction", "arrachage", "arracher", "retirer"],
};
export const demandeToPublicName = {
    DET: "détartrage",
    CTRL: "contrôle",
    DLR: "douleur",
    DKC: "dent cassée",
    TROU: "trou dans une dent",
    IMPLANT: "implant",
    RESC: "couronne ou bridge descellé",
    GENCIVE: "problèmes de gencives",
    BILAN: "bilan", //différence avec CTRL ?
    DDS: "dent de sagesse",
    TRAUMA: "suites de choc ou chute",
    ORTHO: "orthodontie",
    COUR: "couronne",
    DEVIS: "devis",
    URGENCE: "très forte douleur",
    CARIE: "carie suspectée",
    EXTRAC: "dent à extraire",
};
export const rdvCreateModes = [
    "strategor",
    "manuel",
    "aptRequest",
    "doctosync",
    "secretaryBot",
];
//# sourceMappingURL=cadendar-consts.js.map